<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Obras" resource="obras" primaryKey="idobra"
        :records="records" :meta="meta" :columns="columns" />
    </div>
  </div>
</template>
<script>
import CardList from "@/components/Cards/CardList.vue";
import ObraService from "@/services/obra.service";
import { obra } from "@/models/obra";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: obra.filter(column => column.showOnList)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        ObraService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
